import * as z from "../..";
import { userHasRight } from "../../core/rights";
import { Button, ButtonOptions } from "./button";
import { RightLockable } from "./component";

export interface DocumentsButtonOptions extends ButtonOptions {
    entity: "Appointment" | "Call" | "CallItem" | "Contract"
        | "Customer"| "CustomerContact" | "Equipment" | "Inventory"
        | "Order" | "OrderLine" | "OrderSegment" | "PurchaseOrder"
        | "Quote" | "QuoteSegment" | "QuoteLine" | "Site" | "ServiceTech";
}

export class DocumentsButton extends Button {
    entityId: number;
    options: DocumentsButtonOptions & RightLockable

    constructor(options: DocumentsButtonOptions) {
        super(options);
    }

    preRender() {
        const options = this.options;

        super.preRender();

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = false;
                options.classes = undefined;
                options.containerClasses = undefined;
            }
        }
    }

    create() {
        const me = this;

        super.create();

        $(`#${me.id}`).disable();
        $(`#${me.id}`).tie("click", () => {
            if (me.entityId) {
                z.util.showDocuments({
                    id: me.entityId,
                    entity: me.options.entity,
                    readOnly: me.options.rightLocked,
                    title: `${me.options.entity}Documents`,
                    close: me.options.showBadge ? () => me.applyDocumentBadgeValue() : z.util.emptyFn
                });
            }
        });
    }

    setEntityId(entityId: number) {
        var me = this;

        me.entityId = entityId;

        if (me.entityId) {
            $(`#${me.id}`).enable();
            $(`#${me.id}`).find(".button-badge").show();
        } else {
            $(`#${me.id}`).disable();
            $(`#${me.id}`).find(".button-badge").hide();
        }

        if (me.options.showBadge) {
            me.applyDocumentBadgeValue();
        }
    }

    applyDocumentBadgeValue() {
        var me = this;

        if (me.entityId) {
            me.showButtonBadgeSpinner();
            z.ajax({
                url: `${me.options.entity}Attachment?$filter=${me.options.entity}Id eq ${me.entityId}&$top=0&$inlinecount=allpages`
            }).done(function (data) {
                var numDocuments = data.d.__count;
                me.setButtonBadgeValue(numDocuments);
            }).fail(function () {
                me.setButtonBadgeValue(0);
            });
        }
    }
}
